import twConfig from '../../../tailwind.config';
import './base.css';
import './index.scss';
import './overrides.scss';

// move css import to here so they won't be lost when SSR because of lazy load
import 'draft-js/dist/Draft.css';
import '../ui/EditableInput/EditableInput.scss';
import 'emoji-mart/css/emoji-mart.css';

//@ts-ignore
import defaultConfig from 'tailwindcss/defaultConfig';

// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-explicit-any
const resolveConfig: any = require('tailwindcss/lib/util/resolveConfig.js').default;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getConfigFunction = (config: any): any => {
  return resolveConfig([config, defaultConfig]);
};
const tailwindTheme = getConfigFunction(twConfig).theme;

const media = (key: string): string => `
  @media (min-width: ${tailwindTheme.screens[key]})
`;

export const theme = {
  ...tailwindTheme,
  media,
};
